import { Box} from "@mui/material";
import Heading from "./components/heading";
import { useMediaQuery } from "@mui/material";
import Navbar from "./components/navbar";
import food_delivery from "./images/food_delivery.png";
import stock_trend from "./images/stock_trend.png";
import build_resume from "./images/Build_resume.png";
import mvr from "./images/mvr.png";
import job_portal from "./images/job_portal.png";
import chatapp from "./images/chatapp.png";
import { Fade } from "react-awesome-reveal";
import ProjectComponent from "./components/projects";

const Projects = () => {
  const isNotMobile = useMediaQuery("(min-width:1024px)");
  return (
    <Box>
      <Heading name="Projects" />

      <Box
        display="flex"
        maxWidth="80%"
        ml="auto"
        mr="auto"
        mt="3rem"
        flexDirection={"column"}
        gap="2rem"
        mb="10rem"
      >
        <Fade cascade damping={0.1}>
          <ProjectComponent
            title="Real-Time Chat App"
            description={[
              "Developed a full-stack real-time chat app using React.js, Tailwind CSS, and Redux Toolkit. ",
              "Enabled real-time messaging with Socket.IO and WebSockets. ",
              "Created RESTful backend APIs using Node.js and Express.js. ",
              "Implemented JWT-based secure authentication and authorization. ",
              "Utilized Redis for caching active users and improving performance. ",
              "Stored user, chat, and message data in MongoDB with a flexible schema.",
            ]}
            tech="React.js, Tailwind CSS, Redux Toolkit, Socket.IO-client, Node.js, Express.js, JWT, Redis, MongoDB"
            img={chatapp}
            link="https://chatklr.netlify.app/"
            isNotMobile={isNotMobile}
          />

          <ProjectComponent
            title="Job Portal Website"
            description="Developed an intelligent job portal using MERN stack (MongoDB, Express.js, React, Node.js) with integrated AI tools like Natural Language Processing (NLP) for resume parsing and job matching. Implemented a recommendation system to suggest top five job opportunities closely aligned with user profiles using content-based filtering and cosine similarity. Enhanced user engagement through real-time job alerts, dynamic search filters, and chatbot assistance powered by AI."
            tech="React.js, Node.js, Express.js, MongoDB, Python, Scikit-learn, spaCy, Cosine Similarity, Flask, REST API, JWT"
            img={job_portal}
            link="https://job-portal-web-app-vivek87077s-projects.vercel.app/"
            isNotMobile={isNotMobile}
          />

          <ProjectComponent
            title="Food Delivery Website"
            description="Food Delivery Web App (MERN Stack) — Built a real-time food ordering platform from scratch, replicating key features of apps like Zomato. Users can browse restaurants, manage carts, place orders, and track delivery status. Integrated secure authentication, dynamic UI, and responsive design. Designed with a scalable, component-based full-stack architecture that connects users and restaurants seamlessly. "
            tech="MongoDB, Express.js, React.js, Node.js, REST API, JWT, Context API, CSS, Git"
            img={food_delivery}
            link=" "
            isNotMobile={isNotMobile}
          />

          <ProjectComponent
            title="AI Resume Generator"
            description="Developed a dynamic and intelligent resume builder platform that allows users to create personalized, professional resumes with real-time AI assistance. Leveraged Natural Language Processing (NLP) to analyze user inputs and suggest optimized skills, summaries, and job-specific keywords. Integrated drag-and-drop resume sections, live preview, and downloadable PDF export with customizable templates. "
            tech="React.js, Tailwind CSS, Node.js, Express.js, MongoDB, Python, Scikit-learn, spaCy, Flask, NLP, REST API, Axios, JWT"
            img={build_resume}
            link=""
            isNotMobile={isNotMobile}
          />

          <ProjectComponent
            title="Stock Trend Prediction"
            description="Developed a predictive web application that forecasts future stock price trends using deep learning techniques. Implemented an LSTM (Long Short-Term Memory) neural network to analyze historical stock data and identify future trends. Integrated the AI model with a Flask backend and exposed predictions via REST API. Built an interactive and responsive frontend using React.js to visualize stock trends, moving averages, and model predictions. "
            tech="Python, Pandas, NumPy, Matplotlib, Scikit-learn, TensorFlow, Keras, LSTM, Flask, REST API, React.js, Node.js, Express.js"
            img={stock_trend}
            link="https://stock-trend-using-lstm.vercel.app/"
            isNotMobile={isNotMobile}
          />


          <ProjectComponent
            title="Movie Recommmendation System"
            description="Designed and implemented a movie recommendation system that suggests the top five movies most similar to a user-selected title. Utilized content-based filtering by analyzing movie features such as genre, cast, director, and plot keywords. Calculated similarity using cosine similarity on feature vectors to deliver accurate and relevant recommendations."
            tech="Python, Pandas, NumPy, Scikit-learn, NLP, TF-IDF, CountVectorizer, Cosine Similarity, Flask, REST API, React.js"
            img={mvr}
            link=" "
            isNotMobile={isNotMobile}
          />

          
        </Fade>
      </Box>

      <Navbar prev="skills" next="fun" />
    </Box>
  );
};

export default Projects;
